import React from 'react';
import Container from 'components/Container';
import Slider from 'components/Slider';
import { useStores } from 'hooks';

import style from './styles/main.module.scss';

export const PopularProducts = () => {
  const [response, setResponse] = React.useState();
  const { api } = useStores();
  React.useEffect(() => {
    api.newCatalog
      .getPopularProducts()
      .then((res) => {
        setResponse(res);
      })
  }, []);


  if (!response ) return null;

  return (
    <div className={style.popular_products}>
      <Container>
        <h2 className={style.popular_products__title}>Популярные позиции</h2>
        <Slider products={response} />
      </Container>
    </div>
  );
};
